/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Box, IconButton, FormControl, Checkbox, FormHelperText } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { Autocomplete } from '@mui/material';
import CreatePDF from './CreatePdf';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import PropTypes, { func } from 'prop-types'
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { useTheme } from '@mui/material/styles'
import services from '../Service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import Chip from '@material-ui/core/Chip';

var screenCode = "FARMERAVAILABILITY"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

//--------------------sort--------------------------------------------
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'firstName',
        numeric: false,
        disablePadding: false,
        label: 'Farmer Name',
        align: "left"
    },
    {
        id: 'Supplier code',
        numeric: false,
        disablePadding: false,
        label: 'Supplier code',
        align: "left"
    },
    {
        id: 'factoryname',
        numeric: true,
        disablePadding: false,
        label: 'Fresh Collection Center Name',
        align: "left"
    },
    {
        id: 'productName',
        numeric: true,
        disablePadding: false,
        label: 'Product Name',
        align: "left"
    },
    {
        id: 'cropForecastdate',
        numeric: true,
        disablePadding: false,
        label: 'Crop Forecast date',
        align: "left"
    },
    {
        id: 'quantity',
        numeric: true,
        disablePadding: false,
        label: 'Quantity(Kg)',
        align: "right"
    },
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell></TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

//----------------------------------------------------------------

export default function ViewFarmerAvailability(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Farmer Wise Availability Report'
    });

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('FarmerName');

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [farmerList, setFarmerList] = useState([]);

    const [isHidden, setIsHidden] = useState(false);
    const [plotDetails, setPlotDetails] = useState([]);

    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());

    const [selectedOptionsFCC, setSelectedOptionsFCC] = useState([]);
    const [selectedOptionsFarmer, setSelectedOptionsFarmer] = useState([]);

    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        farmerID: 0,
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        farmerID: '',
        toDate: '',
        fromDate: ''
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - plotDetails.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const classes = useStyles();

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptionsFCC,
            farmerID: selectedOptionsFarmer,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
        },

        validationSchema: () => {
            return Yup.object().shape({
                groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
                operationEntityID: Yup.array()
                    .min(1, 'Please select at least one Fresh collection center')
                    .required('Please select at least one Fresh collection center'),
                farmerID: Yup.array()
                    .min(1, 'Please select at least one Farmer')
                    .required('Please select at least one Farmer'),
                toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
                fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
            });
        },

        onSubmit: (values) => {
            trackPromise(SubmitForm());
            setIsHidden(true)
        }
    });

    const [totalValues, setTotalValues] = useState({
        totalQuantity: 0
    });

    //tobackend
    async function SubmitForm() {
        let model = {
            FarmerID: selectedOptionsFarmer.map(x => x).join(',').toString(),
            GroupID: parseInt(formik.values.groupID),
            OperationEntityID: selectedOptionsFCC.map(x => x).join(',').toString(),
            StartDate: new Date(fromDate),
            EndDate: new Date(toDate)
        }
        let newRes = await services.GetAvailabilityDetailsByFarmerID(model);

        let final = newRes.filter(x => x.quantity > 0)
        let res = _.cloneDeep(final);
        res.forEach(x => {
            x.cropForecastdate = x.cropForecastdate.split('T')[0];
            x.quantity = parseFloat(x.quantity).toFixed(2);
        });
        setPlotDetails(res);
        createDataForExcel(res);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(getPermissions());
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        if (selectedOptionsFCC.length > 0) {
            trackPromise(GetFarmerDetailsByMultipleFactoryID());
        }
    }, [formik.values.operationEntityID, selectedOptionsFCC]);

    useEffect(() => {
        clear();
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setPlotDetails([]);
    }, [formik.values.farmerID, operationEntityList]);

    useEffect(() => {
        setPlotDetails([]);
    }, [toDate]);

    useEffect(() => {
        setPlotDetails([]);
    }, [fromDate]);

    useEffect(() => {
        setSelectedOptionsFCC(operationEntityList.map(option => option.value));
    }, [operationEntityList]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptionsFCC(selectedOptions)
    }, [operationEntityList]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptionsFCC,
            farmerID: selectedOptionsFarmer
        })
    }, [selectedOptionsFCC, selectedOptionsFarmer]);

    useEffect(() => {
        if (plotDetails.length != 0) {
            calculateTotalQty();
        }
    }, [plotDetails]);

    const handleSelectChange = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedOptionsFCC(
                selectedOptionsFCC.length === operationEntityList.length ? [] : operationEntityList.map((option) => option.value)
            );
        } else {
            setSelectedOptionsFCC(selectedValues);
        }
        setPlotDetails([]);
    };

    const handleSelectChangeFarmer = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedOptionsFarmer(
                selectedOptionsFarmer.length === farmerList.length
                    ? []
                    : farmerList.map((option) => option.value)
            );
        } else {
            setSelectedOptionsFarmer(selectedValues);
        }
        setPlotDetails([]);
    };

    const handleClearSelection = () => {
        setSelectedOptionsFCC([]);
        setSelectedOptionsFarmer([]);
        setPlotDetails([]);
    };

    const handleClearSelectionFarmer = () => {
        setSelectedOptionsFarmer([]);
        setPlotDetails([]);
    };

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'FARMERAVAILABILITY');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setOperationEntityList(newOptionArray);
        }
    }

    async function GetFarmerDetailsByMultipleFactoryID() {
        let model = {
            operationEntityID: selectedOptionsFCC.map(x => x).join(',').toString()
        }
        var res = await services.GetFarmerDetailsByMultipleFactoryID(model)
        if (res != null) {
            var newOptionArray2 = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray2.push({ label: res[i].givenName, value: res[i].farmerID })
            }
            setFarmerList(newOptionArray2);
        }
    }

    //------------print----------------------------------------------------
    async function createFile() {
        var file = await createDataForExcel(plotDetails);
        var settings = {
            sheetName: 'Farmer Wise Availability Report',
            fileName: 'Farmer Wise Availability Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Farmer Wise Availability Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    function handleSearch(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            var valueV = data["farmerID"];
            var valueV2 = data["firstName"];
            var valueV3 = data["lastName"];

            setValues({
                ...values,
                farmerID: valueV.toString(),
                farmerName: valueV2 == null ? valueV3.toString() : valueV2.toString()
            });
        }
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Farmer Name': x.firstName,
                    'Supplier Code': x.supplierCode,
                    'Fresh Collection Center': x.factoryname,
                    'Product ': x.productName,
                    'Crop Forecast Date': new Date(x.cropForecastdate).toISOString().split('T')[0],
                    'Quantity': x.quantity
                }
                res.push(vr);
            });

            var vrTotal = {
                'Farmer Name': 'Total',
                'Fresh Collection Center': '',
                'supplier Code': '',
                'Product ': '',
                'Crop Forecast Date': '',
                'Quantity': parseFloat(totalValues.totalQuantity).toFixed(2)
            }
            res.push(vrTotal);
            res.push({});

            res.push({});
            res.push({});

            // var vr1 = {
            //     'Farmer Name': "Group: " + selectedSearchValues.groupName,
            //     'Fresh Collection Center': "Fresh Collection Center: " + selectedSearchValues.operationEntityID,
            //     'Product ': "From: " + new Date(fromDate).toISOString().split('T')[0],
            //     'Crop Forecast Date': "To: " + new Date(toDate).toISOString().split('T')[0]
            // }
            // res.push(vr1);
        }
        return res;
    }


    function getSelectedDropdownValuesForReport() {
        const facName = [];
        selectedOptionsFCC.forEach(x => {
            const fildered = operationEntityList.find(y => x === y.value).label
            facName.push(fildered)
        });
        var grpname
        {
            groupList.map((x) => (
                x.groupID == formik.values.groupID ? grpname = x.groupName : null
            ))
        }
        setSelectedSearchValues({
            ...selectedSearchValues,
            operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.map(x => x).join(','),
            groupName: grpname,
            startDate: formik.values.fromDate,
            endDate: formik.values.toDate,
        });
    }
    //---------------------------------------------------------------------

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setSelectedOptionsFarmer([]);
            setPlotDetails([]);
        } else {
            setSelectedOptionsFCC([]);
            setSelectedOptionsFarmer([]);
            setPlotDetails([]);
        }
    }

    async function clear() {
        setPlotDetails([]);
    }

    const renderSelectedValueFCC = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = operationEntityList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderSelectedValueFarmer = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = farmerList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = farmerList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = farmerList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };
    function calculateTotalQty() {
        const totalQuantity = plotDetails.reduce((accumulator, current) => accumulator + parseFloat(current.quantity), 0);
        setTotalValues({
            ...totalValues,
            totalQuantity: totalQuantity,
        });
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Farmer Wise Availability Report   |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptionsFCC}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            renderValue={(selected) => renderSelectedValueFCC(selected)}
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedOptionsFCC.length === operationEntityList.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {operationEntityList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptionsFCC.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptionsFCC.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth error={Boolean(touched.farmerID && errors.farmerID)}>
                                        <InputLabel id="multi-select-label">Farmer *</InputLabel>
                                        <Select
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptionsFarmer}
                                            onChange={handleSelectChangeFarmer}
                                            label="Farmer"
                                            renderValue={(selected) => renderSelectedValueFarmer(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedOptionsFarmer.length === farmerList.length} color="primary" />
                                                All Farmers
                                            </MenuItem>
                                            {farmerList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptionsFarmer.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.farmerID && errors.farmerID && (
                                            <FormHelperText>{errors.farmerID}</FormHelperText>
                                        )}
                                        {selectedOptionsFarmer.length > 0 && (
                                            <IconButton onClick={handleClearSelectionFarmer} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Start Date *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}

                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select End Date"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}                                             {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button type="button" variant="outlined" color="error"
                                            onClick={() => clearAll()}
                                        >
                                            Clear
                                        </Button>
                                        <Button type="submit" color="secondary" variant="outlined"
                                        >
                                            Search
                                        </Button>
                                    </Stack>
                                </Stack>
                                <br />
                                <>
                                    {plotDetails.length != 0 ? (
                                        <>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                    <Paper className={classes.paper}>
                                                        <TableContainer>
                                                            <Table
                                                                className={classes.table}
                                                                aria-labelledby="tableTitle"
                                                                aria-label="enhanced table"
                                                            >
                                                                <EnhancedTableHead
                                                                    classes={classes}
                                                                    order={order}
                                                                    orderBy={orderBy}
                                                                    onRequestSort={handleRequestSort}
                                                                    rowCount={plotDetails.length}
                                                                />
                                                                <TableBody>
                                                                    {stableSort(plotDetails, getComparator(order, orderBy))
                                                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                        .map((row, index) => {
                                                                            const labelId = `enhanced-table-checkbox-${index}`;

                                                                            return (
                                                                                <TableRow>
                                                                                    <TableCell component="th" id={labelId} scope="row" padding="none">
                                                                                        {row.name}
                                                                                    </TableCell>
                                                                                    <TableCell >{row.firstName}</TableCell>
                                                                                    <TableCell >{row.supplierCode}</TableCell>
                                                                                    <TableCell >{row.factoryname}</TableCell>
                                                                                    <TableCell >{row.productName}</TableCell>
                                                                                    <TableCell >{new Date(row.cropForecastdate).toLocaleDateString('en-US',
                                                                                        { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell align='right'>{row.quantity}</TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })}
                                                                    <TableRow>
                                                                        <TableCell></TableCell>
                                                                        <TableCell sx={{ fontWeight: "bold" }} align='left' >Total</TableCell>
                                                                        <TableCell></TableCell>

                                                                        <TableCell></TableCell>
                                                                        <TableCell></TableCell>
                                                                        <TableCell></TableCell>
                                                                        <TableCell align="right" style={{ fontWeight: "bold" }}>
                                                                            {(totalValues.totalQuantity === 0 || totalValues.totalQuantity === "-")
                                                                                ? '-'
                                                                                : parseFloat(totalValues.totalQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>

                                                        <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25]}
                                                            component="div"
                                                            count={plotDetails.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onPageChange={handleChangePage}
                                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                                        />
                                                    </Paper>
                                                </Card>
                                            </Stack>
                                        </>
                                    ) : null}
                                </>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {plotDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Farmer Wise Availability Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={plotDetails}
                                    searchData={selectedSearchValues}
                                    totalValues={totalValues}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}